// extracted by mini-css-extract-plugin
export default {"std-icon":"svg-icon_std-icon__RBoru"};